// extracted by mini-css-extract-plugin
module.exports = {"container":"AreasTable_container__jDqFe","tableContainer":"AreasTable_tableContainer__1h67O","colorOption":"AreasTable_colorOption__2PzFa"};